import { Button } from '@/components/ui/common/Button'
import * as React from 'react'

interface IntroStageProps {
  startTask: () => void
  moneyPerPump: number
  totalBalloons: number
}

export const IntroStage: React.FC<IntroStageProps> = ({
  startTask,
  moneyPerPump,
  totalBalloons
}) => (
  <div className="flex flex-col items-center gap-6">
    <h2 className="text-center text-xl font-bold">Balloon Analogue Risk Task (BART)</h2>
    <p className="text-center">
      W tym zadaniu będziesz pompować balony, aby zdobyć jak najwięcej pieniędzy. Za każde
      pompowanie otrzymasz {moneyPerPump} zł, ale jeśli balon pęknie, stracisz wszystkie
      pieniądze z tego balonu.
    </p>
    <p className="text-center">
      Możesz w dowolnym momencie zdecydować się na "wypłatę" i zachować zarobione
      pieniądze, zanim balon pęknie. Twoim celem jest zdobycie jak największej sumy
      pieniędzy.
    </p>
    <div className="w-full rounded-md bg-[#2bcaca]/10 p-4">
      <ul className="list-disc space-y-2 pl-6">
        <li>Każde pompowanie zwiększa wartość balonu o {moneyPerPump} zł</li>
        <li>Jeśli balon pęknie, tracisz wszystkie pieniądze z tego balonu</li>
        <li>
          Jeśli zdecydujesz się na wypłatę, zachowujesz pieniądze i przechodzisz do
          następnego balonu
        </li>
        <li>Łącznie będziesz pompować {totalBalloons} balonów</li>
      </ul>
    </div>
    <Button className="bg-indigo-600 hover:bg-indigo-700" onClick={startTask}>
      Rozpocznij zadanie
    </Button>
  </div>
)
